import { FC, memo } from "react";
import { SIDE } from "_constants";
import { StatusMessageBase } from "components/common/StatusMessageBase";

type Props = {
  className?: string;
  team?: string | null;
  side: SIDE;
  Icon?: React.ComponentType<any>;
  title?: string;
  description?: string;
  normalizedCode: string;
  status: any;
  width: number;
  height: number;
};

export const StatusMessage: FC<Props> = memo((props) => {
  const bottomCodes: string[] = [];

  const sideIconResolver = (normalizedCode: string, side: "home" | "away") => {
    const { Icon } = props;
    const rotateCodes = [
      "2201", // At Bat
      "2202", // Hit
      "2203", // Home Run
    ];
    const isHome = side === "home";

    if (Icon && isHome && rotateCodes.includes(normalizedCode)) {
      const Flipped: React.FC = () => (
        <div style={{ transform: "scaleX(-1)", transformOrigin: "center" }}>
          <Icon />
        </div>
      );
      return Flipped;
    }
    return Icon ?? null;
  };

  return (
    <StatusMessageBase
      {...props}
      bottomCodes={bottomCodes}
      accentColor="#002607"
      sideIconResolver={sideIconResolver}
    />
  );
});
